import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-af7577b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Company" }
const _hoisted_2 = {
  class: "Company-intro",
  "data-scroll-section": ""
}
const _hoisted_3 = { class: "Company-intro-title h1" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Company-intro-img" }, [
  /*#__PURE__*/_createElementVNode("picture", null, [
    /*#__PURE__*/_createElementVNode("source", { srcset: "/dev/company/hero.png 1x, /dev/company/hero@2x.png 2x" }),
    /*#__PURE__*/_createElementVNode("img", {
      src: "/dev/company/hero.png",
      alt: "Hero company"
    })
  ])
], -1))
const _hoisted_5 = {
  class: "Company-content grid padded",
  "data-scroll-section": ""
}
const _hoisted_6 = { class: "Company-content-left" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "Company-content-right" }
const _hoisted_9 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LineByLine = _resolveComponent("LineByLine")!
  const _component_AppearObject = _resolveComponent("AppearObject")!
  const _component_ParallaxObject = _resolveComponent("ParallaxObject")!
  const _component_ButtonHover = _resolveComponent("ButtonHover")!
  const _component_LayoutNotConnected = _resolveComponent("LayoutNotConnected")!

  return (_openBlock(), _createBlock(_component_LayoutNotConnected, null, {
    default: _withCtx(() => [
      _createElementVNode("main", _hoisted_1, [
        _createElementVNode("section", _hoisted_2, [
          _createVNode(_component_ParallaxObject, {
            class: "Company-intro-inner grid padded",
            ratio: -0.2
          }, {
            default: _withCtx(() => [
              _createVNode(_component_AppearObject, { class: "Company-intro-content" }, {
                default: _withCtx(() => [
                  _createElementVNode("h1", _hoisted_3, [
                    _createVNode(_component_LineByLine, {
                      innerHTML: _ctx.$t('company.title')
                    }, null, 8, ["innerHTML"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["ratio"]),
          _hoisted_4
        ]),
        _createElementVNode("section", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h2", {
              class: "h3",
              innerHTML: _ctx.$t('company.description1')
            }, null, 8, _hoisted_7),
            _createVNode(_component_ButtonHover, {
              href: _ctx.$t('company.link'),
              target: "_link",
              class: "Company-content-btn button"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('company.cta')), 1)
              ]),
              _: 1
            }, 8, ["href"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("p", {
              class: "text-lg",
              innerHTML: _ctx.$t('company.description2')
            }, null, 8, _hoisted_9)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}